import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../../../models/usuarios.service';
import {Router} from '@angular/router'

@Component({
    selector: 'app-minhas-vendas',
    templateUrl: './minhas-vendas.component.html',
    styleUrls: ['./minhas-vendas.component.scss']
})
export class MinhasVendasComponent implements OnInit {
    constructor(
        private users:UsersService,
        private router : Router
    ) { 

    }

    ngOnInit(): void {
        if(!(this.isAdmin || this.isAfiliado))
           this.router.navigate([this.rotaAtual()])
        
    }

    get isFornecedor(){
        return this.users.isFornecedor;
    }
    get isAdmin(){
        return this.users.isAdmin;
    }
    get isAfiliado(){
        return this.users.isAfiliado;
    }
    rotaAtual()
    {
        if(this.isAdmin || this.isAfiliado)
        {
            return '/minhasVendas'
        }
        else 
        {
            return '/vendasDiaria'
        }
    } 


    isVendasRootRoute(): boolean 
    {
        let result: boolean = String(window.location.pathname).endsWith(this.rotaAtual()) 
        return result
    }

}
